import React, { useState, useEffect } from 'react';

export default function LocationFilter({ onApply, onClear, appliedFilters = {} }) {
  const [open, setOpen] = useState(false);
  const [area, setArea] = useState('');
  const [city, setCity] = useState('');
  const [stateVal, setStateVal] = useState('');
  const [country, setCountry] = useState('');
  const [q, setQ] = useState('');

  useEffect(() => {
    // initialize from appliedFilters when opened or when filters change externally
    setArea(appliedFilters.area || '');
    setCity(appliedFilters.city || '');
    setStateVal(appliedFilters.state || '');
    setCountry(appliedFilters.country || '');
    setQ(appliedFilters.q || '');
  }, [appliedFilters]);

  function handleApply() {
    const f = {};
    if (area) f.area = area;
    if (city) f.city = city;
    if (stateVal) f.state = stateVal;
    if (country) f.country = country;
    if (q) f.q = q;
    if (onApply) onApply(f);
    setOpen(false);
  }

  function handleClear() {
    setArea('');
    setCity('');
    setStateVal('');
    setCountry('');
    setQ('');
    if (onClear) onClear();
    setOpen(false);
  }

  return (
    <div className="relative">
      <label className="text-[10px] sm:text-sm font-medium mr-2">Location</label>
      <select
        onChange={(e) => {
          const val = e.target.value;
          if (val === 'custom') setOpen(true);
          if (val === 'all') {
            handleClear();
          }
        }}
        defaultValue=""
        className="px-2 py-2 border border-gray-200 rounded-lg text-sm bg-white cursor-pointer"
      >
        <option value="" disabled>Choose</option>
        <option value="all">All Locations</option>
        <option value="custom">Custom</option>
      </select>

      {open && (
        <div className="absolute right-0 mt-2 w-72 bg-white border border-gray-200 rounded-lg shadow-lg p-3 z-20">
          <input value={area} onChange={(e) => setArea(e.target.value)} placeholder="Area" className="w-full mb-2 px-2 py-2 border rounded" />
          <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="City" className="w-full mb-2 px-2 py-2 border rounded" />
          <input value={stateVal} onChange={(e) => setStateVal(e.target.value)} placeholder="State" className="w-full mb-2 px-2 py-2 border rounded" />
          <input value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Country" className="w-full mb-2 px-2 py-2 border rounded" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Keywords (optional)" className="w-full mb-2 px-2 py-2 border rounded" />
          <div className="flex gap-2">
            <button onClick={handleApply} className="flex-1 bg-red-500 text-white px-3 py-2 rounded">Apply</button>
            <button onClick={handleClear} className="flex-1 border px-3 py-2 rounded">Clear</button>
          </div>
        </div>
      )}
    </div>
  );
}

